import React, { HTMLAttributes } from 'react'
import { styles } from './TextDuoImages.css'
import { SanityAssetDocument } from 'next-sanity'
import { PortableTextObject } from 'sanity'
import { DuoImages } from '@otomoro/components/shared/DuoImages'
import { SectionHeader } from '@otomoro/components/shared/SectionHeader'

interface TextDuoImagesProps extends HTMLAttributes<Element> {
	tag: string
	titleText: PortableTextObject
	orientation: boolean
	description: PortableTextObject
	largeImage: SanityAssetDocument
	smallImage: SanityAssetDocument
}

export const TextDuoImages: React.FC<TextDuoImagesProps> = ({
	tag,
	titleText,
	orientation,
	description,
	largeImage,
	smallImage,
}) => {
	if (!largeImage || !smallImage) return null

	const { base } = styles()

	return (
		<section className={base()}>
			{titleText && <SectionHeader tag={tag} title={titleText} description={description} />}
			<DuoImages
				withText={titleText !== undefined}
				orientation={orientation}
				largeImage={largeImage}
				smallImage={smallImage}
			/>
		</section>
	)
}
